import { ChatMessageItem } from "../../types";

import useUpdateSession from "../../Utils/useUpdateSession";
import useUpdateSessionList from "../../Utils/useUpdateSessionList";
import { useUpdateMessage } from "../../Utils/useUpdateMessage";
import { useLatest } from "react-use";
import { useAtomValue } from "jotai";
import { curSessionIdAtom } from "../../store";
import useMessageScroll from "../../Utils/useMessageScroll";
import { getSessionInfo } from "../../polyfills";

export function useOnNewMessage() {
    const chat = useUpdateMessage();
    const sessionManager = useUpdateSession();
    const curSessionIdRef = useLatest(useAtomValue(curSessionIdAtom));
    const updateSessions = useUpdateSessionList();
    const scroller = useMessageScroll();

    async function onNewMessage(message: ChatMessageItem) {
        // 如果是撤回消息
        if (message.operatorType === "1") {
            return onRetract(message);
        }

        const sessionId = message.sessionUid;
        const sessionExists = sessionManager.checkSessionExist(sessionId);

        // 新的会话开启session
        if (!sessionExists) {
            const session = await getSessionInfo(sessionId);
            sessionManager.addSession(session);
        }

        chat.addMessage(sessionId, message);
        updateSessions();

        if (sessionId === curSessionIdRef.current) {
            scroller.scrollToBottom();
        } else {
            sessionManager.markSessionUnRead(sessionId);
        }
    }

    // 执行撤回操作
    function onRetract(message: ChatMessageItem) {
        chat.removeMessage(message.sessionUid, message.guid);
        updateSessions();
    }

    return onNewMessage;
}
